import { Record, Map } from 'immutable';
import copyOptions from '../../config/copyOptions';

export default class MatchingSpec extends Record(
  { query: '',
    threshold: '20',
    outputSchema: '',
    outputTable: '',
    enteredName: undefined }) {

  get ready() { return true; }

  get valid() {
    return this.jobName !== '' &&
      this.query.length > 0 &&
      this.outputTable.length > 0 &&
      this.outputSchema.length > 0 &&
      !isNaN(parseInt(this.threshold, 10)) &&
      parseInt(this.threshold, 10) > 0 &&
      parseInt(this.threshold, 10) <= 100;
  }

  get jobName() {
    if (this.enteredName !== undefined) {
      return this.enteredName;
    }
    else {
      var queryDesc = '';
      if (this.query.length < 33) {
        queryDesc = this.query;
      }
      else {
        queryDesc = `${this.query.substring(0, 15)}...${this.query.substring(this.query.length - 15, this.query.length)}`;
      }

      return `Matching query '${queryDesc}'`;
    }
  }

  get configJson() {
    // TODO: Make this real. This is currently placeholder code
    return {
      'jobType': 'giraffe',
      'config': [
        {
          'jobType': 'sql_runner',
          'config': {
            'queryType': 'Unload',
            'dbInfo': {
              'driver': 'Redshift',
              'server': 'bl-int-analytics1.cxtyzogmmhiv.us-east-1.redshift.amazonaws.com',
              'port': 5439,
              'database': 'analytics',
              'username': 'fake'
            },
            'fromFile': false,
            'unloadInfo': {
              'query': this.query,
              'delimiter': '\t',
              'gzip': false
            }
          }
        },
        {
          'jobType': 'matching_runner',
          'config': {
            'threshold': String(Number(this.threshold) / 100),
            'outputTable': this.outputTable,
            'outputSchema': this.outputSchema,
            'copyOpts': new Map(copyOptions.map((opt) => ([opt.value, false]))).toJS(),
          }
        },
        {
          'jobType': 'sql_runner',
          'config': {
            'queryType': 'Import',
            'dbInfo': {
              'driver': 'Redshift',
              'server': 'bl-int-analytics1.cxtyzogmmhiv.us-east-1.redshift.amazonaws.com',
              'port': 5439,
              'database': 'analytics',
              'username': 'fake'
            },
            'fromFile': true
          }
        }
      ]
    };
  }
}
